import {
  Directive,
  input,
  ElementRef,
  Renderer2,
  OnInit,
  effect,
  inject,
} from '@angular/core';

export type StatusType =
  | 'active'
  | 'upcoming'
  | 'ended'
  | 'approved'
  | 'rejected'
  | 'pending'
  | 'created'
  | 'in_progress'
  | 'Tasdiqlandi'
  | 'Bekor qilindi'
  | 'Yuborilgan'
  | 'Passiv';

@Directive({
  selector: '[libStatus]',
  standalone: true,
})
export class StatusDirective implements OnInit {
  libStatus = input<StatusType>('pending');
  statusVariant = input<'pill' | 'badge' | 'dot'>('pill');

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    effect(() => {
      this.applyStatusStyles();
    });
  }

  private statusClasses = {
    active: 'bg-green-100 text-green-700 border-green-200',
    upcoming: 'bg-blue-100 text-blue-700 border-blue-200',
    ended: 'bg-gray-100 text-gray-700 border-gray-200',
    approved: 'bg-green-100 text-green-700 border-green-200',
    rejected: 'bg-red-100 text-red-700 border-red-200',
    pending: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    created: 'bg-sky-100 text-sky-700 border-sky-200',
    in_progress: 'bg-amber-100 text-amber-700 border-amber-200',
    Tasdiqlandi: 'bg-green-100 text-green-700 border-green-200',
    Yuborilgan: 'bg-[#FFECD9] text-[#D98739] border-yellow-200',
    'Bekor qilindi': 'bg-gray-100 text-gray-700 border-gray-200',
    Passiv: 'bg-blue-100 text-blue-700 border-blue-200',
  };

  private statusTexts = {
    active: 'Aktiv',
    upcoming: 'Kutilmoqda',
    ended: 'Yakunlangan',
    approved: 'Tasdiqlandi',
    rejected: 'Bekor qilindi',
    pending: 'Kutilmoqda',
    created: 'Yaratilgan',
    in_progress: 'Jarayonda',
    Tasdiqlandi: 'Tasdiqlandi',
    Yuborilgan: 'Yuborilgan',
    'Bekor qilindi': 'Bekor qilindi',
    Passiv: 'Passiv',
  };

  ngOnInit() {
    this.applyStatusStyles();
  }

  private applyStatusStyles() {
    Object.values(this.statusClasses).forEach((classes) => {
      classes.split(' ').forEach((cls) => {
        this.renderer.removeClass(this.el.nativeElement, cls);
      });
    });

    const baseClasses = this.getBaseClasses();
    baseClasses.forEach((cls) => {
      this.renderer.addClass(this.el.nativeElement, cls);
    });

    const statusClasses = this.statusClasses[this.libStatus()];
    statusClasses.split(' ').forEach((cls) => {
      this.renderer.addClass(this.el.nativeElement, cls);
    });

    this.renderer.setProperty(
      this.el.nativeElement,
      'textContent',
      this.statusTexts[this.libStatus()],
    );
  }

  private getBaseClasses(): string[] {
    const common = [
      'inline-flex',
      'items-center',
      'font-medium',
      'transition-colors',
    ];

    switch (this.statusVariant()) {
      case 'pill':
        return [
          ...common,
          'px-3',
          'py-1',
          'rounded-full',
          'text-xs',
          'whitespace-nowrap',
        ];
      case 'badge':
        return [...common, 'px-2', 'py-1', 'rounded-md', 'text-xs', 'border'];
      case 'dot':
        return [
          ...common,
          'px-2',
          'py-1',
          'rounded-full',
          'text-xs',
          'before:content-[""]',
          'before:w-2',
          'before:h-2',
          'before:rounded-full',
          'before:mr-2',
          'before:bg-current',
        ];
      default:
        return [...common, 'px-3', 'py-1', 'rounded-full', 'text-xs'];
    }
  }
}
